import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=95818d74&scoped=true&"
import script from "./SettingsMenu.vue?vue&type=script&lang=js&"
export * from "./SettingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMenu.vue?vue&type=style&index=0&id=95818d74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95818d74",
  null
  
)

export default component.exports